import { Box, SxProps, useMediaQuery } from '@mui/material';
import Lottie from 'lottie-react';
import ServerErrorLottie from '../../assets/lottie/server-error.json';

/**
 * ServerError component
 *
 * This component displays a server error animation using Lottie.
 * It adjusts the size of the animation based on the screen size.
 *
 * @returns {JSX.Element} The rendered ServerError component
 */
const ServerError = ({ sx = {} }: { sx?: SxProps }) => {
  // Media queries for responsive design
  const smallScreen = useMediaQuery('(max-width: 425px)');
  const mediumScreen = useMediaQuery('(max-width: 1366px)');

  return (
    <Box
      sx={{
        position: 'absolute',
        top: '57%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        ...sx,
      }}
    >
      <Lottie
        animationData={ServerErrorLottie}
        loop={false}
        style={{
          // Adjust width based on screen size
          width: smallScreen ? '300px' : mediumScreen ? '500px' : '600px',
          height: 'auto',
        }}
      />
    </Box>
  );
};

export default ServerError;
